import React from 'react';
import NavBar from '../components/navbar';
import { Paper, Typography } from '@material-ui/core';
import '../styles/gewinnspiel.css';

const errorClass = "gewinnspiel error";
const containerClass = "gewinnspiel container";
const iframeContainerClass = "gewinnspiel iframecontainer";
const typographyPaperClass = "gewinnspiel typographypaper";

const links = {
    6: 'https://docs.google.com/forms/d/e/1FAIpQLSfoCkRXogqSH6X2AZlGeRqdnbi1m0XMGOWYhe_ZrFf7sDJs5g/viewform?embedded=true',
    7: 'https://docs.google.com/forms/d/e/1FAIpQLSdGp-Vl6FH-5mvJeQvwINdi0DYZdVL8W9HupyTSbqJl6KjJGA/viewform?embedded=true',
    8: 'https://docs.google.com/forms/d/e/1FAIpQLSf7_MN946oS15D-GJPVAbLuRy19nm969L8jNPvkTPHSRkOD5Q/viewform?embedded=true',
    9: 'https://docs.google.com/forms/d/e/1FAIpQLSfm5-jssfXBO_nZfOMmzExTdnIAsPGuAr_BDBq_K8NvSmyy5g/viewform?embedded=true',
    10: 'https://docs.google.com/forms/d/e/1FAIpQLSd6OjKwT3pnr1lYhvyLV7zh2Bk3lpG1rAv1zTWFBKdR96d6lQ/viewform?embedded=true',
    11: 'https://docs.google.com/forms/d/e/1FAIpQLSeAyifYMBLpCHoVpNjOGD6ftAKgGVXHzbEumsm_sGLsVD-DIA/viewform?embedded=true'
}

export const klassen = Object.keys(links);

class Gewinnspiel extends React.Component {

    render() {
        const src = links[this.props.klasse];
        if(!src)
            setTimeout(() => this.props.history.push('/'), 5000);
        return (
            <>
                <div className={containerClass}>
                    <NavBar />
                    <Paper className={typographyPaperClass}>
                        <Typography align="center" variant="h2" >Gewinnspiel</Typography>
                    </Paper>
                    {src ?
                        <Paper className={iframeContainerClass}>
                            <iframe src={src} title="Gewinnspiel" width="100%" height="100%" frameborder="0" marginheight="0" marginwidth="0">Lade Gewinnspiel...</iframe>
                        </Paper>
                        :
                        <div className={errorClass}>
                            <Typography variant="h4">
                                An error occured while loading the page!<br />
                                It seems like the content you are looking for cannot be found.<br />
                                If you clicked on a link and landed here, please contact the webmaster.
                            </Typography>
                            <Typography variant="h6">You will be redirected in 5 seconds.</Typography>
                        </div>
                    }
                </div>
            </>
        );
    }
}

export default Gewinnspiel;